module.exports = __webpack_public_path__ + "static/media/Seam_6750.a2be4944.jpg";